import { HDate, HHourInterval, HString, PhaseSlotLogTypes, RouteCardDto, TimeZones } from '@shared/src/public-api';
import { DockDto } from '../dock/DockDto';

export class SlotInfoDto {

    public dock: DockDto;

    public slotId: number;
    public tenantId: number;
    public onDate: HDate;
    public interval: HHourInterval;
    public intervalDock: HHourInterval;
    public intervalLift: HHourInterval;
    public isBlockedBookSlotSystem: boolean;
    public isBlockedEnterSystem: boolean;
    public isBlockedExitSystem: boolean;
    public isSlotBlocked: boolean;
    public isSlotBlockedExternal: boolean;
    public incompatibleSlot: boolean;
    public addressTimetableIntervalId: number;

    public additionalInformation: string;
    public multiSlot: boolean;

    public pendingSlotQty: number = 0;
    public assignedSlots: number = 0;

    public noShow: boolean = false;
    public isLateAtSlot: boolean = false;

    public slotStatus: PhaseSlotLogTypes;

    public requiresSlot: boolean = false;

    public timeZoneSlot: TimeZones;



    static buildFromRouteCardDto(value: RouteCardDto): SlotInfoDto {
        let result = new SlotInfoDto();
        result.incompatibleSlot = value.incompatibleSlot;
        result.isBlockedBookSlotSystem = value.isBlockedBookSlotSystem;
        result.isBlockedEnterSystem = value.isBlockedEnterSystem;
        result.isBlockedExitSystem = value.isBlockedExitSystem;
        result.isSlotBlocked = value.isSlotBlocked;
        result.isSlotBlockedExternal = value.isSlotBlockedExternal;
        result.interval = SlotInfoDto.getHHourInterval(value);
        result.intervalDock = SlotInfoDto.getHHourIntervalDock(value);
        result.intervalLift = SlotInfoDto.getHHourIntervalLift(value);
        result.onDate = SlotInfoDto.getDate(value);
        result.slotId = SlotInfoDto.getSlotId(value);
        result.slotStatus = SlotInfoDto.getSlotStatus(value);
        result.multiSlot = SlotInfoDto.getMultiSlot(value);

        result.pendingSlotQty = value.pendingSlotQty;
        result.assignedSlots = 0;
        if (value != null)
            if (value.assignedSlots != null && value.assignedSlots != undefined)
                result.assignedSlots = value.assignedSlots.length;

        if (result.pendingSlotQty == 0 && result.assignedSlots == 0)
            result.noShow = true;
        return result;
    }

    static buildListFromRouteCardDto(value: RouteCardDto): SlotInfoDto[] {

        let list: SlotInfoDto[] = new Array();
        if (value == null || value.assignedSlots == null || value.assignedSlots.length == undefined || value.assignedSlots.length == 0) {
            list.push(this.buildFromRouteCardDto(value));
            return list;
        }

        value.assignedSlots.forEach(element => {
            list.push(element);
        });

        return list;
    }

    static toToolTipTextString(list: SlotInfoDto[]): string {
        let result = "";
        let primer = true;
        list.forEach(p => {
            if (!primer)
                result += ", ";
            result += HString.concat(result, "", HDate.toGetString(p.onDate));
            result += HString.concat(result, " ", HHourInterval.toScreenString(p.interval));
            if (p.additionalInformation)
                result += HString.concat(result, " additionalInfo:", p.additionalInformation);
            primer = false;
        });

        return result;
    }
    static getAdditionalInformation(list: SlotInfoDto[]): string {
        if (list == null)
            return "";
        for (let i = 0; i < list.length; i++)
            if (list[i].additionalInformation)
                return list[i].additionalInformation;
        return "";
    }
    static toHourIntervalsString(slot: SlotInfoDto): string {
        return HHourInterval.toScreenString(slot.interval)
    }
    static toDateString(slot: SlotInfoDto): String {
        return HDate.getDateString(slot.onDate);
    }

    static getDate(r: RouteCardDto): HDate {
        if (r != null)
            if (r.assignedSlots != null)
                if (r.assignedSlots.length != undefined && r.assignedSlots.length > 0)
                    return r.assignedSlots[0].onDate;
        HDate.nullDate();
    }
    static getHHourInterval(r: RouteCardDto): HHourInterval {
        if (r != null)
            if (r.assignedSlots != null)
                if (r.assignedSlots.length != undefined && r.assignedSlots.length > 0)
                    return r.assignedSlots[0].interval;
        return HHourInterval.nullInterval();
    }
    static getHHourIntervalDock(r: RouteCardDto): HHourInterval {
        if (r != null)
            if (r.assignedSlots != null)
                if (r.assignedSlots.length != undefined && r.assignedSlots.length > 0)
                    return r.assignedSlots[0].intervalDock;
        return HHourInterval.nullInterval();
    }
    static getHHourIntervalLift(r: RouteCardDto): HHourInterval {
        if (r != null)
            if (r.assignedSlots != null)
                if (r.assignedSlots.length != undefined && r.assignedSlots.length > 0)
                    return r.assignedSlots[0].intervalLift;
        return HHourInterval.nullInterval();
    }
    static getMultiSlot(r: RouteCardDto): boolean {
        if (r != null)
            if (r.assignedSlots != null)
                if (r.assignedSlots.length != undefined && r.assignedSlots.length > 0)
                    return r.assignedSlots[0].multiSlot;
        return false;
    }
    static getSlotId(r: RouteCardDto): number {
        if (r != null)
            if (r.assignedSlots != null)
                if (r.assignedSlots.length != undefined && r.assignedSlots.length > 0)
                    return r.assignedSlots[0].slotId;
        return 0;
    }
    static getSlotStatus(r: RouteCardDto): PhaseSlotLogTypes {
        if (r != null)
            if (r.assignedSlots != null)
                if (r.assignedSlots.length != undefined && r.assignedSlots.length > 0)
                    return r.assignedSlots[0].slotStatus;
        return null;
    }
}